import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SpinnerOverlay from "../../components/Spinner/SpinnerOverlay";
import { ApplicationFunctions, useAuth } from '../../contexts/authContext';
import { useNotifications } from '../../contexts/notificationContext';
import ItemSearchResult from '../../models/ItemSearchResult';
import DataService from '../../services/data.service';
import { DataResult } from '../../types/Result';
import ItemRevisionCard from './Components/ItemRevisionCard';
import Unauthorized from './../Authentication/Unauthorized';
import ItemFilterForm, { ItemSearchCriteria } from './FilterForm/ItemFilterForm';

const ItemSearchView: React.FC = () => {
    const [items, setItems] = useState<ItemSearchResult[]>([]);
    const [showSpinner, setShowSpinner] = useState<boolean>(false);
    const navigate = useNavigate();
    const { handleResult, handleException } = useNotifications();

    function search(criteria: ItemSearchCriteria): void {
        setShowSpinner(true)
        DataService
            .post<DataResult<ItemSearchResult[]>>(`api/v1/ItemRevisions/Search/`, criteria)
            .then(response => {
                setShowSpinner(false);
                handleResult(response);
                if (response.isSuccesful === true && response.data) {
                    setItems(response.data);
                    if (response.data.length === 1) {
                        itemClicked(response.data[0]);
                    }
                }
            })
            .catch(e => {
                setShowSpinner(false);
                handleException(e)
            });
    }

    const { isAuthorizedForItemType } = useAuth();
    if (!isAuthorizedForItemType(ApplicationFunctions.SearchItemRevision)) {
        return (<Unauthorized />);
    }

    let results = items.map((item, index) => {
        return <ItemRevisionCard itemRevision={item} handleItemClicked={itemClicked} index={index} key={index} />
    });

    function itemClicked(itemRevision: ItemSearchResult) {
        let url = '/plm/Items/ItemRevision/' + itemRevision.itemRevisionId;
        let navigateTitle = itemRevision.itemNr + ' - v' + itemRevision.revisionNumber;
        navigate(url, { state: { title: navigateTitle, fromMenu: false } });
    }

    return (
        <div className='main-content'>
            <ItemFilterForm handleSearch={search} forBom={false} />
            <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'space-around' }}>
                {results}
            </div>
            {showSpinner && (<SpinnerOverlay />)}
        </div>
    );
}
export default ItemSearchView;